<template>
  <!-- The signed-in user's photo, or their initials until one is uploaded. The caller sets any ring. -->
  <img
    v-if="photoUrl"
    :height="size"
    :src="photoUrl"
    :width="size"
    alt=""
    class="shrink-0 rounded-full object-cover"
  />
  <span
    v-else
    :style="{ width: `${size}px`, height: `${size}px`, fontSize: `${Math.round(size * 0.38)}px` }"
    aria-hidden="true"
    class="grid shrink-0 place-items-center rounded-full bg-primary-100 font-semibold text-primary-700"
  >
    {{ initials }}
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { TwnAccountAvatarProps } from '@/domains/admin-panel/components/atoms/twn-account-avatar/TwnAccountAvatar.types'

import { useAuthUser } from '@/composables/use-auth-user/useAuthUser'
import { getUserInitials } from '@/domains/users/composables/use-user-helper/useUserHelper'

defineProps<TwnAccountAvatarProps>()

const { user } = useAuthUser()

// Jetstream always resolves a URL, generating an initials image when nothing is uploaded; only a stored path is a photo.
const photoUrl = computed(() => (user.value?.profile_photo_path ? user.value.profile_photo_url : null))
const initials = computed(() => getUserInitials(user.value))
</script>
